// Export files templates choices for extraction, usually, they are excel files.
import { extractionOutputFileTemplatesService } from '@/services/estimation/extraction-output-file-templates.service';
import axios from 'axios';

const initialState = () => ({
  extractionOutputFileTemplates: [],
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const CancelToken = axios.CancelToken;
let cancelTokens = {
  extractionOutputFileTemplates: null,
};

const actions = {
  // Get output files templates
  getExtractionOutputFileTemplates({ commit }) {
    if (cancelTokens.extractionOutputFileTemplates) {
      cancelTokens.extractionOutputFileTemplates.cancel('Multiple requests.');
    }
    cancelTokens.extractionOutputFileTemplates = CancelToken.source();

    commit('GET_OUTPUT_FILE_TEMPLATES');
    return extractionOutputFileTemplatesService
      .getExtractionOutputFileTemplates({ cancelToken: cancelTokens.extractionOutputFileTemplates })
      .then(
        (response) => {
          commit('SUCCESS', response);
        },
        (error) => {
          if (axios.isCancel(error)) return;
          commit('ERROR', error.response);
          throw error;
        },
      );
  },
  addExtractionOutputFileTemplate({ commit }, { file }) {
    commit('CRUD_OUTPUT_FILE_TEMPLATE');
    return extractionOutputFileTemplatesService
      .addExtractionOutputFileTemplate({ file, cancelToken: cancelTokens.extractionOutputFileTemplates })
      .then(
        (files) => {
          commit('ADD_OUTPUT_FILE_TEMPLATE_SUCCESS', files);
        },
        (error) => {
          if (axios.isCancel(error)) return;
          commit('ERROR', error.response);
          throw error;
        },
      );
  },
  deleteExtractionOutputFileTemplate({ commit }, { templateId }) {
    commit('CRUD_OUTPUT_FILE_TEMPLATE');
    return extractionOutputFileTemplatesService.deleteExtractionOutputFileTemplate({ templateId }).then(
      (response) => {
        commit('DELETE_OUTPUT_FILE_TEMPLATE_SUCCESS', templateId);
      },
      (error) => {
        if (axios.isCancel(error)) return;
        commit('ERROR', error.response);
        throw error;
      },
    );
  },
};

const mutations = {
  GET_OUTPUT_FILE_TEMPLATES(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
    state.extractionOutputFileTemplates = [];
  },
  SUCCESS(state, outputFileTemplates) {
    state.status = {
      error: null,
      pending: false,
      resolved: true,
      rejected: false,
    };
    state.extractionOutputFileTemplates = outputFileTemplates;
  },
  CRUD_OUTPUT_FILE_TEMPLATE(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  ADD_OUTPUT_FILE_TEMPLATE_SUCCESS(state, files) {
    state.status = {
      error: null,
      pending: false,
      resolved: true,
      rejected: false,
    };
    files.forEach((file) => state.extractionOutputFileTemplates.push(file));
  },
  DELETE_OUTPUT_FILE_TEMPLATE_SUCCESS(state, templateId) {
    state.status = {
      error: null,
      pending: false,
      resolved: true,
      rejected: false,
    };

    const templateIndex = state.extractionOutputFileTemplates.findIndex((template) => template.id === templateId);
    if (templateIndex > -1) state.extractionOutputFileTemplates.splice(templateIndex, 1);
  },
  ERROR(state, error) {
    state.status = {
      ...state.status,
      error: error,
      pending: false,
      rejected: true,
    };
  },
};

const getters = {
  extractionOutputFileTemplates: (state) => state.extractionOutputFileTemplates,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const extractionOutputFileTemplates = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
